import type { AnalyticsEventPayload, CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import { COHORT, NOT_ENROLLED, VARIATION } from '@atlassian/jira-common-util-get-experiment-group';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import {
	type UIAnalyticsEvent,
	type AnalyticsAttributes,
	fireUIAnalytics,
	fireTrackAnalytics,
} from '@atlassian/jira-product-analytics-bridge';

export const fireButtonAnalytics = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	actionSubjectId: string,
	attributes?: AnalyticsAttributes,
) => {
	fireUIAnalytics(
		createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'button',
		}),
		actionSubjectId,
		{ ...attributes, editionAwarenessFreeUpgradeFastFollowModal: true },
	);
};

export const isJSMFastFollowExperimentVariation = () => {
	// eslint-disable-next-line jira/ff/unsafe-no-exposure
	const [config] = UNSAFE_noExposureExp('jsm_ea_upgrade_modal_revision');
	return config.get(COHORT, NOT_ENROLLED) === VARIATION;
};

export const fireJSMFastFollowFeatureExposed = (createAnalyticsEvent: CreateUIAnalyticsEvent) => {
	// eslint-disable-next-line jira/ff/unsafe-no-exposure
	const [config, fireExperimentExposure] = UNSAFE_noExposureExp('jsm_ea_upgrade_modal_revision');
	fireExperimentExposure();

	fireTrackAnalytics(createAnalyticsEvent({}), 'feature exposed', {
		flagKey: 'jsm_ea_upgrade_modal_revision',
		value: config.get(COHORT, NOT_ENROLLED),
		growthInitiative: 'transmuters',
	});
};
